import { SpeakerLabelTextInterface } from '@/App/remotion/MainPlayer/types/Element/VideoElement';

export default function SpeakerLabelText({ element }: { element: SpeakerLabelTextInterface }) {
  return <div style={element?.style}>{element?.content}</div>;
}
